/**
 * Utility helper for dashboard reports selection logic.
 * Kept in utils so business logic can be reused across components.
 */
import {
  DashboardReportKey,
  REPORTS_FOR_MANAGEMENT,
  REPORTS_FOR_REP,
  REPORTS_DERMAZONE_EXTRA,
} from '../routes/dashboard/dashboard.constants';
import { UserRole } from '../interfaces/user-role';
import { isManagementRole, isRepresentativeRole } from './user-roles';

export function getReportsForRole(
  role: UserRole | null | undefined,
  companyId: string | undefined,
): DashboardReportKey[] {
  const isDermazone = companyId === '5c990b2b4382f61588e2c0c7';

  const base = isManagementRole(role)
    ? [...REPORTS_FOR_MANAGEMENT]
    : isRepresentativeRole(role)
      ? [...REPORTS_FOR_REP]
      : [];

  if (
    base.length > 0 &&
    isDermazone &&
    !base.includes(REPORTS_DERMAZONE_EXTRA)
  ) {
    base.push(REPORTS_DERMAZONE_EXTRA);
  }

  return base;
}

